export { P50ProductDetailsPage as default } from './components/P50ProductDetailsPage';
